module.exports = __webpack_public_path__ + "img/exercise_notes.feffa587.svg";